var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F8EDD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.25 46.375L58.75 56.9375V39.125L48.25 46.375ZM21.25 38.875V56.9375L31.75 46.375L21.25 38.875ZM35.1875 46.4375L23 58.75H57L44.8125 46.4375C42.8125 44.5 37.1875 44.5 35.1875 46.4375ZM56.25 35.375V37.8125L57.8125 36.6875L56.25 35.375ZM23.75 35.375L22.3125 36.5625L23.75 37.5625V35.375Z",
    fill: "#F6BD60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.375 44.5625L53.75 39.5V21.25H26.25V39.5L33.5 44.5625C36.5 41.8125 43.4375 41.8125 46.375 44.5625ZM48.75 33.75H35V31.25H48.75V33.75ZM31.25 26.25H37.5V28.75H31.25V26.25ZM31.25 36.25H48.75V38.75H31.25V36.25Z",
    fill: "#F6BD60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.5f89cefd9ce06ffdb6442901b5ce742c.svg";
export { ForwardRef as ReactComponent };